var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 225,
    y: 100.17,
    width: 50,
    height: 50,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 225,
    y: 350,
    width: 50,
    height: 50,
    rx: 5,
    ry: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.04,400h62.59c2.07,0,3.15-2.31,2.04-3.91l-128.14-128.14c-4.9-4.9-7.33-11.32-7.32-17.73-.01-6.42,2.42-12.84,7.32-17.73l128.22-128.22c1.57-1.57.46-4.27-1.77-4.27h-62.6c-1.07,0-2.1.36-2.95.98l-58.76,58.76c-24.01,24.01-37.5,56.58-37.5,90.53h0c0,32.96,12.74,64.58,35.43,88.36l59.9,59.9c.94.94,2.21,1.46,3.54,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.96,400h-62.59c-2.07,0-3.15-2.31-2.04-3.91l128.14-128.14c4.9-4.9,7.33-11.32,7.32-17.73.01-6.42-2.42-12.84-7.32-17.73L61.25,104.27c-1.57-1.57-.46-4.27,1.77-4.27h62.6c1.07,0,2.1.36,2.95.98l58.76,58.76c24.01,24.01,37.5,56.58,37.5,90.53h0c0,32.96-12.74,64.58-35.43,88.36l-59.9,59.9c-.94.94-2.21,1.46-3.54,1.46Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.95dff6a7cc146ca93e207cb98b657fa1.svg";
export { ForwardRef as ReactComponent };